<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 23.999a12 12 0 1 1 8.485-3.515A11.919 11.919 0 0 1 12 23.999zm0-12.078a4.006 4.006 0 0 0-4 4v.273a.8.8 0 0 0 .8.8h6.4a.8.8 0 0 0 .805-.8v-.273A4.006 4.006 0 0 0 12 11.922zm0-5.926a2.545 2.545 0 1 0 2.4 2.54A2.477 2.477 0 0 0 12 5.999z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-profile',
});
</script>
